import EventManager from '../__internals__/EventManager'
import createEventType from '../__internals__/createEventType'
import trackEvent from './trackEvent'

const trackClick =
  (eventManager: EventManager) => (nodeId: string, eventName?: string) => {
    trackEvent(eventManager)({
      ...createEventType('click', eventName),
      customInteraction: {
        key: 'node_id',
        value: nodeId,
      },
    })
  }

export default trackClick
